import { toast } from "sonner";
import { cheer } from "@/components/Mascot";

export const RARITY = {
  common: { label: "Common", color: "#94a3b8" },
  rare: { label: "Rare", color: "#38bdf8" },
  epic: { label: "Epic", color: "#c084fc" },
  legendary: { label: "Legendary", color: "#fbbf24" },
};

export const dailyChanged = () => window.dispatchEvent(new Event("daily-changed"));

// Toast each finished quest and tell the Today panel to reload.
export function celebrate(quests) {
  (quests || []).forEach((q) => toast.success(`Quest complete: ${q.label}`, {
    description: `+${q.credits} credits · King Wolf: "${cheer("quest")}"`,
    icon: <img src="/brand/mwp_coin.webp" alt="" className="w-6 h-6 rounded-full" />,
  }));
  dailyChanged();
}

export const clock = (s) => {
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  return `${h}h ${String(m).padStart(2, "0")}m ${String(sec).padStart(2, "0")}s`;
};
